interface ToggleInputProps {
  id: string;
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  /** Visually hide the label (grid cells). */
  hideLabel?: boolean;
  title?: string;
  children?: never;
}

/** Accessible switch for Excluded and Active toggles. */
export function ToggleInput({ id, label, checked, onChange, disabled, hideLabel, title }: ToggleInputProps) {
  return (
    <span className={`inline-flex items-center gap-2 ${hideLabel ? "min-h-[44px] min-w-[44px] justify-center" : ""}`}>
      <button
        id={id}
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={hideLabel ? label : undefined}
        aria-labelledby={hideLabel ? undefined : `${id}-label`}
        title={title ?? label}
        disabled={disabled}
        onClick={() => onChange(!checked)}
        className={`relative inline-flex h-6 w-11 shrink-0 items-center rounded-full border-2 border-transparent transition-colors focus:outline-none focus:ring-2 focus:ring-brand-green-50 disabled:cursor-default disabled:opacity-50 cursor-pointer ${checked ? "bg-brand-green" : "bg-gray-300"}`}
      >
        <span aria-hidden="true" className={`inline-block h-5 w-5 rounded-full bg-white shadow transition-transform ${checked ? "translate-x-5" : "translate-x-0"}`} />
      </button>
      {!hideLabel && (
        <span id={`${id}-label`} className="text-sm text-gray-700">
          {label}
        </span>
      )}
    </span>
  );
}
